module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/pricing.9d77b4b6.svg";